var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 4V1.5C3.33317 1.03977 3.70627 0.666666 4.1665 0.666666H14.1665C14.6267 0.666666 14.9998 1.03977 14.9998 1.5V13.1667C14.9998 13.6269 14.6267 14 14.1665 14H11.6665V16.4992C11.6665 16.9599 11.2916 17.3333 10.8275 17.3333H0.838883C0.375492 17.3333 0 16.9628 0 16.4992L0.00216663 4.83406C0.00224996 4.37342 0.3772 4 0.841183 4H3.33317ZM1.66868 5.66667L1.66682 15.6667H9.99983V5.66667H1.66868ZM4.99983 4H11.6665V12.3333H13.3332V2.33333H4.99983V4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector (4).509aae462f90f9fa41ef9f57cd24d70b.svg";
export { ForwardRef as ReactComponent };